import Vue from "vue/dist/vue.esm";
import moment from 'moment/moment';
// 出走表 選手表 詳細

var detailAthletes = Vue.extend({
  template: `
  <table class="table table-vote-number table-align-middle">
    <thead class="bg-gray-lighter text-bold">
      <tr class="bg-gray-lighter" height="34">
        <th rowspan="3"　height="137">予想</th>
        <th rowspan="3">枠番</th>
        <th rowspan="3">車番</th>
        <th rowspan="3">選手名</th>
        <th rowspan="3">年齢</th>
        <th rowspan="3">府県</th>
        <th rowspan="3">期別</th>
        <th rowspan="3">級班</th>
        <th rowspan="3">脚質</th>
        <th rowspan="3">ギア倍数</th>
        <th colspan="14">直近4ヶ月の成績</th>
        <th colspan="9">3回前までの成績</th>
        <th rowspan="3">コメント</th>
      </tr>
      <tr height="34">
        <th rowspan="2">競走得点</th>
        <th rowspan="2">1着</th>
        <th rowspan="2">2着</th>
        <th rowspan="2">3着</th>
        <th rowspan="2">着外</th>
        <th rowspan="2">勝率</th>
        <th rowspan="2">2連対率</th>
        <th rowspan="2">3連対率</th>
        <th colspan="4">決まり手</th>
        <th rowspan="2">S</th>
        <th rowspan="2">B</th>
        <th colspan="3">今回開催</th>
        <th colspan="3">前回開催</th>
        <th colspan="3">前々回開催</th>
      </tr>
      <tr height="34" class="text-nowrap">
        <th>逃</th>
        <th>捲</th>
        <th>差</th>
        <th>マ</th>
        <th>開催</th>
        <th>初日</th>
        <th>成績</th>
        <th>開催</th>
        <th>初日</th>
        <th>成績</th>
        <th>開催</th>
        <th>初日</th>
        <th>成績</th>
      </tr>
    </thead>
    <tbody class="text-nowrap">
      <tr :class="['bg-lighten-' + athlete.entry_num, {'is-disabled': !athlete.on_sale}]" v-for="(athlete, key, index) in raceInfo.race_athletes" :key="athlete.id">
        <td height="68" class="bg-white text-center">
          <span v-if="raceInfo.prediction.marks">{{raceInfo.prediction.marks[index]}}</span>
        </td>
        <td :rowspan="joiningWakuNum(athlete.waku_num)" class="bg-white text-center" v-if="isFirstWaku(key)">{{athlete.waku_num}}</td>
        <td :class="'bg-' + athlete.entry_num" class="text-center text-bold">{{athlete.entry_num}}</td>
        <td>
          <a :href="athlete.profile_url" target="_blank" :class="{'text-through': !athlete.on_sale}">{{athlete.name}}</a>
          <span v-if="!athlete.on_sale">（取消）</span>
        </td>
        <td>{{athlete.age}}</td>
        <td>{{athlete.pref_name}}</td>
        <td>{{athlete.graduate_period}}</td>
        <td>{{athlete.class_name}}{{athlete.group_name}}</td>
        <td>{{athlete.leg_quality}}</td>
        <td>
          <span class="text-through text-base">{{athlete.gear_ratio_before || ''}}</span>
          {{athlete.gear_ratio}}
        </td>
        <td>{{athlete.average_point_formatted}}</td>
        <td>{{athlete.first_count}}</td>
        <td>{{athlete.second_count}}</td>
        <td>{{athlete.third_count}}</td>
        <td>{{athlete.out_rank_count}}</td>
        <td>{{athlete.average_win_formatted}}</td>
        <td>{{athlete.average_rentai_formatted}}</td>
        <td>{{athlete.average_rentai3_formatted}}</td>
        <td>{{athlete.nige_count}}</td>
        <td>{{athlete.makuri_count}}</td>
        <td>{{athlete.sashi_count}}</td>
        <td>{{athlete.mark_count}}</td>
        <td>{{athlete.standing_count}}</td>
        <td>{{athlete.back_count}}</td>
        <td>{{athlete.history_data1 ? athlete.history_data1.vel_name : ''}}</td>
        <td>{{athlete.history_data1 ? moment(athlete.history_data1.open_from) : ''}}</td>
        <td>
          <div v-if="athlete.history_data1">
            <span v-for="short_box in athlete.history_data1.short_boxes">
              <p>{{short_box.event_name}} {{short_box.rank || short_box.note}}</p>
            </span>
          </div>
        </td>
        <td>{{athlete.history_data2 ? athlete.history_data2.vel_name : ''}}</td>
        <td>{{athlete.history_data2 ? moment(athlete.history_data2.open_from) : ''}}</td>
        <td>
          <div v-if="athlete.history_data2">
            <span v-for="short_box in athlete.history_data2.short_boxes">
              <p>{{short_box.event_name}} {{short_box.rank || short_box.note}}</p>
            </span>
          </div>
        </td>
        <td>{{athlete.history_data3 ? athlete.history_data3.vel_name : ''}}</td>
        <td>{{athlete.history_data3 ? moment(athlete.history_data3.open_from) : ''}}</td>
        <td>
          <div v-if="athlete.history_data3">
            <span v-for="short_box in athlete.history_data3.short_boxes">
              <p>{{short_box.event_name}} {{short_box.rank || short_box.note}}</p>
            </span>
          </div>
        </td>
        <td>{{athlete.comment}}</td>
      </tr>
    </tbody>
  </table>
  `,
  methods: {
    computeAvePoint: function(num) {
      return (Math.floor(num / 10) / 100).toPrecision(4);
    },
    // 同一の枠番がいくつ有るかを出力
    joiningWakuNum: function(num) {
      var race_athelets = this.raceInfo.race_athletes;
      var waku_nums = [];
      
      for (var key in race_athelets) {
        waku_nums.push(race_athelets[key].waku_num);
      }
      
      var count = 0;
      for (var i=0; i<waku_nums.length; i++) {
        count = (waku_nums[i] == num) ? count + 1 : count;
      }
      
      return count;
    },
    // 指定した車番の選手が同一枠番の最初かどうかの判定
    isFirstWaku: function(syaban) {
      var race_athelets = this.raceInfo.race_athletes;
      var waku_nums = [];
      var syabans = Object.keys(race_athelets);
      
      for (var key in race_athelets) {
        waku_nums.push(race_athelets[key].waku_num);
      }
      
      var targetIndex = waku_nums.indexOf(race_athelets[syaban].waku_num);
      
      if (syaban == syabans[targetIndex]) {
        return true;
      } else {
        return false;
      }
    },
    moment: function(date) {
      if (moment(date, 'YYYYMMDD').format('MM/DD') === 'Invalid date') {
        return ''
      }
      return moment(date, 'YYYYMMDD').format('MM/DD');
    }
  }
});

export default {
  detailAthletes
}
